// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../formatDuration/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var formatDuration = convertToFP(fn, 1);
export default formatDuration;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/formatDuration/index.js
// module id = 875
// module chunks = 0